// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__wXAVH","tile":"style_tile__0xY4r","label":"style_label__iWhnI"};